import {EventEmitter, Injectable} from '@angular/core';
import {BaseService} from './BaseService';
import {APIServiceConnector} from './APIServiceConnector';
import {AppSettings} from './../Library/AppSettings';
import * as enumModels from '../Models/EnumModels';
import {EntityCodes, RecurrenceSearch_GroupBy} from '../Models/EnumModels';
import {ListResponse, SimpleResponse, StatusCodeCount} from '../Models/ResponseModels';
import {
    RecurrenceFilterModel,
    RecurrenceLookup,
    RecurrenceQuery,
    RecurrenceRegister,
    RecurrenceSearch
} from '../Models/RequestModels';
import {MasterDataService} from './MasterDataService';
import * as alasql from 'alasql';
import * as moment from 'moment';
import * as _ from 'lodash';
import {cloneDeep, find, findIndex} from 'lodash';
import {RecurrenceStatus, RecurrenceStatusLabel} from '../enum/RecurrenceStatus';
import {TranslateService} from "@ngx-translate/core";
import {PropertyBasicInfo} from "../Models/GlobalEntities";

@Injectable()
export class RecurrenceConsoleService extends BaseService {
    public Cache_RecurrenceData = [];
    public PropertyDateFormat: string;
    SelectedRecurrence: any;
    RecurrenceDeleted = new EventEmitter();

    constructor(public apiService: APIServiceConnector, public masterService: MasterDataService, public translate: TranslateService) {
        super();
        this.BaseURL = AppSettings.URL_ComplainService;
    }

    Recurrence_Search_Multi(req: ListResponse): void {
        if (req == null)
            return;

        if (req.Result == null)
            return;

        for (let i = 0; i < req.Result.length; i++) {
            let row = req.Result[i];

            let propId = row.PropertyId;
            row.CallDescription = this.masterService.MasterData_GetMutli(propId, row.CallDescriptionsId, enumModels.EntityCodes.CallDescriptions, row.CallDescription);
            row.Location = this.masterService.MasterData_GetMutli(propId, row.LocationId, enumModels.EntityCodes.Location, row.Location);
            row.Department = this.masterService.MasterData_GetMutli(propId, row.DepartmentId, enumModels.EntityCodes.Dept, row.Department);
            row.Status = this.masterService.MasterData_GetMutli(propId, row.StatusCode, enumModels.EntityCodes.ComplainSatuses, row.Status);
        }
    }

    Recurrence_Search(req: RecurrenceSearch): Promise<ListResponse> {
        return this.apiService.postAPI(this.BaseURL, 'Recurrence/Recurrence_Search', req, false).then(data => {
            let Property = this.masterService.LoggedInUserData.Properties.find(propObj => propObj.PropertyId == req.PropertyId);
            this.PropertyDateFormat = this.masterService.GetPropertyDateFormat(req.PropertyId);
            data.Result.forEach(obj => {
                obj.PropertyCode = Property.PropertyCode;
                obj.PropertyName = Property.PropertyName;
            });

            this.Recurrence_Search_Multi(data);

            this.Cache_RecurrenceData = data.Result;

            return data;
        })
    }

    Recurrence_Query(req: RecurrenceQuery, trackLoading = false): Promise<ListResponse> {
        if (!req.Properties || !req.Properties.length) {
            return Promise.resolve(new ListResponse());
        }
        const request = Object.assign(new RecurrenceQuery(), req);
        if (!request.RoomStatus) {
            delete request.RoomStatus
        }

        return this.apiService.postAPI(this.BaseURL, 'Recurrence/Recurrence_Search', request, trackLoading)
            .then(data => {
                return request.GroupBy === RecurrenceSearch_GroupBy.None
                    ? this.TransformRecurrenceList(data)
                    : this.TransformRecurrenceGroupList(data, request.GroupBy, request.Properties);
            });
    }

    Recurrence_QueryCount(req: RecurrenceQuery, trackLoading = false): Promise<SimpleResponse<Array<StatusCodeCount>>> {
        return this.apiService.postAPI(this.BaseURL, 'Recurrence/Recurrence_Query_Counts', req, trackLoading)
    }

    RecurrenceDeleteForResults(response: ListResponse, row) {
        if (response && response.Result && response.Result.length) {
            const idx = findIndex(response.Result, { RecurrenceId: row.RecurrenceId});
            if (idx >= 0) {
                let results = cloneDeep(response.Result);
                results = [
                    ...results.slice(0, idx),
                    row,
                    ...results.slice(idx+1)
                ];
                response = Object.assign(new ListResponse(), response, {
                    Result: results
                })
            }
        }
        return response;
    }

    Delete(id): Promise<SimpleResponse> {
        return this.apiService.getAPI(this.BaseURL, 'Recurrence/Recurrence_Delete?RecurrenceId=' + this.URLEncode(id)).then(data => {
            if (data.Result) {
                data.Result[0].PropertyCode = this.masterService.LoggedInUserData.Properties.find(propObj => propObj.PropertyId == data.Result[0].PropertyId).PropertyCode;
                this.Recurrence_Search_Multi(data);
                let index = this.Cache_RecurrenceData.findIndex(obj => obj.RecurrenceId == data.Result[0].RecurrenceId);
                this.Cache_RecurrenceData[index] = data.Result[0];
                return data;
            }
            return data;

        });
    }

    GetActivityLog(req: RecurrenceLookup) {
        return this.apiService.postAPI(this.BaseURL, 'Recurrence/RecurrenceLookup', req, true).then(data => {
            //this.ActivityLog_Multi(data);
            return data;
        });
    }

    GetModificationLog(propertyId: number, req: RecurrenceLookup) {
        return this.apiService.postAPI(this.BaseURL, 'Recurrence/RecurrenceModificationLookup', req, true).then(data => {
            return this.Trans_ModificationLog(propertyId, data);
        });
    }

    Recurrence_Filter(req: RecurrenceFilterModel) {
        let queryWhere: string = ' From ? Where';
        let param = [];
        let response: ListResponse = new ListResponse();
        let data = this.Cache_RecurrenceData;

        param.push(data);
        alasql.fn.convertDate = function (d) {
            d = new Date(d);
            return d;
        }
        if (req.Properties[0] && req.Properties[0] != null) {
            param.push(req.Properties[0]);
            queryWhere = queryWhere + ' PropertyId = ?'
        }
        if (req.Keyword && req.Keyword != null) {
            param.push(req.Keyword, req.Keyword, req.Keyword, req.Keyword);
            queryWhere = queryWhere + ' And (CallDescription LIKE CONCAT("%",?,"%") OR Location LIKE CONCAT("%",?,"%") OR Department LIKE CONCAT("%",?,"%") OR Comments LIKE CONCAT("%",?,"%"))';


        }
        if (req.StatusCode != null) {
            param.push(req.StatusCode);
            queryWhere = queryWhere + ' And StatusCode = ?';

        }
        if (req.Locations && req.Locations.length > 0) {
            param.push(req.Locations);
            queryWhere = queryWhere + ' And LocationId In @(?)';

        }
        if (req.Departments && req.Departments.length > 0) {
            param.push(req.Departments);
            queryWhere = queryWhere + ' And DepartmentId In @(?)';

        }
        if (req.CallDescriptions && req.CallDescriptions.length > 0) {
            param.push(req.CallDescriptions);
            queryWhere = queryWhere + ' And CallDescriptionsId In @(?)';

        }
        if (req.RoomStatus) {
            param.push(req.RoomStatus);
            queryWhere = queryWhere + ' And RoomStatus = ?';

        }
        if (req.lstEndPattern && req.lstEndPattern.length > 0) {
            //param.push(req.lstEndPattern);
            let EndPattern = _.cloneDeep(req.lstEndPattern);
            let index = EndPattern.indexOf(enumModels.RecurrencePatterns_End.NoEndDate);
            if (index >= 0) {
                EndPattern.splice(index, 1);
                param.push(EndPattern);
                queryWhere = queryWhere + ' And ((EndPattern = 3 And IsGuestCall = false) Or (EndPattern In @(?)))';
            }
            else {
                param.push(req.lstEndPattern);
                queryWhere = queryWhere + ' And EndPattern In @(?)';
            }
        }
        if (req.DateRangeStart && req.DateRangeEnd) {
            param.push(req.DateRangeStart, req.DateRangeEnd);
            queryWhere = queryWhere + ' And convertDate(ReopenDateTime) Between ? And ?';

        }
        if (req.Months && req.StatusCode != "Y" && req.StatusCode != "D" && req.Months <= 12 && req.Months > 0) {
                let currentDate = new Date();
                let currentMonth = currentDate.getMonth();
                let lowerDateLimit = new Date();
                lowerDateLimit.setMonth(currentMonth - req.Months);
                param.push(lowerDateLimit, currentDate);
                queryWhere = queryWhere + ' And convertDate(LastUpdateTime) Between ? And ?';
        }
        if (req.OrderBy) {
            let breakString = req.OrderBy.split(' ');
            let colName = breakString[0];
            let orderType = breakString[1];
            param.push(colName);
            queryWhere = queryWhere + ' Order By ' + colName + ' ' + orderType;
        }
        else {
            queryWhere = queryWhere + ' Order By convertDate(LastUpdateTime) Desc';
        }


        let skipRecords = req.PageSize * (req.PageNumber - 1);
        response.TotalRecords = alasql('Select Count(*) as C' + queryWhere, param)[0].C;
        queryWhere = queryWhere + ' Offset ' + skipRecords + ' Rows Fetch Next ' + req.PageSize + ' Rows Only';
        data = alasql('Select *' + queryWhere, param);
        response.Result = data;
        this.setStatusLabel(response.Result);
        response.CurrentPage = req.PageNumber;
        return response;
    }

    setStatusLabel(data) {
        if (!data || !data.length) {
            return;
        }
        data.forEach(element => {
            element.StatusName = this.GetStatusLabel(element);
        });
    }

    private GetStatusLabel(row) {
        return {
            [RecurrenceStatus.Active]: RecurrenceStatusLabel.Active,
            [RecurrenceStatus.Expired]: RecurrenceStatusLabel.Expired,
            [RecurrenceStatus.Deleted]: RecurrenceStatusLabel.Deleted
        } [row.Status];
    }

    Recurrence_Save(req: RecurrenceRegister): Promise<SimpleResponse> {
        return this.apiService.postAPI(this.BaseURL, 'Recurrence/Recurrence_Save', req).then(data => {
            return data;
        })
    }

    ExportRecToExcel(req: RecurrenceFilterModel) {
        let filterdata = this.Recurrence_Filter(req);

        if (filterdata.TotalRecords > 0) {
            this.TransformDate(filterdata);
            alasql.promise('SELECT Status, Department, Location, Category, CallDescription as [Call Description], _RecurrencePattern as [Recur Type], _RecurrenceFrequency as [Recurs Every], StartDateTime as [Start Date Time], _EndPattern as [End Pattern], LoggerName as [Logger Name], _RoomStatus as [Room Status], RequestedBy as [Requested By] INTO XLSX("RecurrenceJobs.xlsx",{headers:true}) FROM ?', [filterdata.Result]);
            // .then(data => { console.log(data) });
        }
    }

    TransformDate(filterdata: any): void {
        if (filterdata.TotalRecords > 0) {
            for (let i = 0; i < filterdata.Result.length; i++) {
                //let row = filterdata.Result[i];
                  //Set Start Date Time
                if (filterdata.Result[i].StartDateTime != null) {
                    filterdata.Result[i].StartDateTime = moment(filterdata.Result[i].StartDateTime).format(this.PropertyDateFormat);
                }
            }
        }
    }

    private TransformRecurrenceList(data: any) {
        const transform = new ListResponse();
        if (!data || data.HasError) {
            transform.HasError = true;
            transform.Errors = (data && data.Errors);
            return transform;
        }
        transform.TotalRecords = data.TotalRecords;
        transform.CurrentPage = data.CurrentPage;
        transform.Result = (data.Result || []).map(recurrence => this.TransformRecurrence(recurrence))
        return transform;
    }

    private TransformRecurrence(row: any) {
        const propertyId = row.PropertyId;
        if (propertyId) {
            const propertyDateFormat = this.masterService.GetPropertyDateFormat(row.PropertyId);
            const Property = this.masterService.LoggedInUserData.Properties.find(propObj => propObj.PropertyId == propertyId);
            // update property-code and property-name
            row.PropertyCode = Property.PropertyCode;
            row.PropertyName = Property.PropertyName;
            // update masters multilingual
            row.CallDescription = this.masterService.MasterData_GetMutli(propertyId, row.CallDescriptionsId, enumModels.EntityCodes.CallDescriptions, row.CallDescription);
            row.Location = this.masterService.MasterData_GetMutli(propertyId, row.LocationId, enumModels.EntityCodes.Location, row.Location);
            row.Department = this.masterService.MasterData_GetMutli(propertyId, row.DepartmentId, enumModels.EntityCodes.Dept, row.Department);
            row.Status = this.masterService.MasterData_GetMutli(propertyId, row.StatusCode, enumModels.EntityCodes.ComplainSatuses, row.Status);
            // update status multilingual
            row.StatusName = this.GetStatusLabel(row);
            // property-dateformat
            // room status
            row._RoomStatus = this.roomStatus_GetMulti(row);
            // recurrence pattern
            row._RecurrencePattern = this.recurrencePattern_GetMulti(row);
            // recurrence frequency
            row._RecurrenceFrequency = this.recurrenceFrequency_GetMulti(row);
            // recurrence end pattern
            row._EndPattern = this.recurrenceEndPattern_GetMulti(row, propertyDateFormat);
        }
        return row;
    }

    private TransformRecurrenceGroupList(data, groupedBy: RecurrenceSearch_GroupBy, propertyIds: number[] = []) {
        const transform = new ListResponse();
        if (!data || data.HasError) {
            transform.HasError = true;
            transform.Errors = (data && data.Errors);
            return transform;
        }
        transform.TotalRecords = data.TotalRecords;
        transform.CurrentPage = data.CurrentPage;
        const selectedEntities = ((_groupedBy) => {
            switch (_groupedBy) {
                case RecurrenceSearch_GroupBy.CallCategories: return [EntityCodes.CallCategories];
                case RecurrenceSearch_GroupBy.CallDescriptions: return [EntityCodes.CallDescriptions];
                case RecurrenceSearch_GroupBy.Dept: return [EntityCodes.Dept];
                case RecurrenceSearch_GroupBy.Location: return [EntityCodes.Location];
                default: return [];
            }
        })(groupedBy);
        const cache = this.masterService.GetTypeaheadMasters(propertyIds, selectedEntities);
        const properties = propertyIds.reduce((acc, p) => {
            acc[p] = this.masterService.GetProperty(p);
            return acc;
        }, {}) as Record<number, PropertyBasicInfo>;
        transform.Result = (data.Result || [])
            .map(group => this.TransformRecurrenceGroup(group, groupedBy, properties, cache))
            // only provide first 100 for rendering, else UI hangs
            .slice(0, 100)
        return transform;
    }

    private roomStatus_GetMulti(row: any) {
        switch (row.RoomStatus) {
            case 'V': return this.translate.instant('LBL.VACANT');
            case 'O': return this.translate.instant('LBL.OCCUPIED');
            case 'A': return this.translate.instant('LBL.VACANT_OCCUPIED');
        }
    }

    private recurrencePattern_GetMulti(row: any) {
        switch (row.RecurrencePattern) {
            case 1: return this.translate.instant('LBL.HOURLY');
            case 2: return this.translate.instant('LBL.DAILY');
            case 3: return this.translate.instant('LBL.WEEKLY');
            case 4: return this.translate.instant('LBL.MONTHLY');
        }
    }

    private recurrenceFrequency_GetMulti(row: any) {
        switch (row.RecurrencePattern) {
            case 1: return this.translate.instant('LBL.RECURS_EVERY') + ' ' + row.RecurrenceFrequency + ' ' + this.translate.instant('LBL.HOUR');
            case 2: return this.translate.instant('LBL.RECURS_EVERY') + ' ' + row.RecurrenceFrequency + ' ' + this.translate.instant('LBL.DAY');
            case 3: return this.translate.instant('LBL.RECURS_EVERY') + ' ' + this.translate.instant('LBL.WEEK') + ' ' + this.translate.instant('LBL.ON') + ' ' + row.Dow;
            case 4:
                if (!row.Dow) {
                    return row.RegisterAtEndOfMonth
                        ? this.translate.instant('LBL.RECURS_EVERY') + ' ' + row.RecurrenceFrequency + ' ' + this.translate.instant('LBL.MONTHS') + ', ' + this.translate.instant('LBL.ON') + ' ' + this.translate.instant('LBL.END_OF_MONTH')
                        : '';
                }
                const translated = this.translate.instant('LBL.RECURS_EVERY') + ' ' + row.RecurrenceFrequency + ' ' + this.translate.instant('LBL.MONTHS') + ', ' + this.translate.instant('LBL.ON') + ' ' + row.Dow;
                return row.RegisterAtEndOfMonth
                        ? translated + ',' + this.translate.instant('LBL.END_OF_MONTH')
                        : translated;
        }
    }

    private recurrenceEndPattern_GetMulti(row: any, dateFormat: string) {
        switch (row.EndPattern) {
            case 1: return this.translate.instant('LBL.ENDS_ON') + ' ' + moment(row.EndDateTime).format(dateFormat);
            case 2: return this.translate.instant('LBL.ENDS_AFTER') + ' ' + row.MaxRecurrence + ' ' + this.translate.instant('LBL.OCCURRENCES');
            case 3: return row.IsGuestCall
                ? this.translate.instant('LBL.UPON_CHECKOUT')
                : this.translate.instant('LBL.NO_END_DATE');
        }
    }

    private TransformRecurrenceGroup(group: any,
                                     groupedBy: RecurrenceSearch_GroupBy,
                                     properties: Record<number, PropertyBasicInfo>,
                                     cache: Record<EntityCodes, Array<any>>) {
        let groupName = ''
        if (groupedBy === RecurrenceSearch_GroupBy.Property) {
            const property = properties[group.Id];
            group.GroupName = property && property.PropertyName;
            return group;
        }
        let key = '';
        switch (groupedBy) {
            case RecurrenceSearch_GroupBy.CallCategories:
            case RecurrenceSearch_GroupBy.CallDescriptions:
            case RecurrenceSearch_GroupBy.Location:
                key = 'Description';
                break;
            case RecurrenceSearch_GroupBy.Dept:
                key = 'Name';
                break;
        }
        if (!key) {
            return group;
        }
        for (const entity in cache) {
            const list = cache[entity];
            const item = find(list, {Id: group.Id});
            if (item) {
                group.GroupName = item[key];
                break;
            }
        }
        return group;
    }

    private Trans_ModificationLog(propertyId: number, response: ListResponse) {
        if (response == null) {
            return response;
        }
        if (response.Result == null) {
            return response;
        }
        for (let i = 0; i < response.Result.length; i++) {
            const row = response.Result[i];
            const propertyDateFormat = this.masterService.GetPropertyDateFormat(propertyId);
            row._RecurrencePattern = this.recurrencePattern_GetMulti(row);
            row._RecurrenceFrequency = this.recurrenceFrequency_GetMulti(row);
            row._RoomStatus = this.roomStatus_GetMulti(row);
            row._EndPattern = this.recurrenceEndPattern_GetMulti(row, propertyDateFormat);
            row.LoggerName = this.masterService.MasterData_GetMutli(
                propertyId,
                row.Logger,
                enumModels.EntityCodes.Staff,
                "");
        }
        return response
    }
}
